var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { client } from './client';
/**
 * Get all UX panels for a specific level.
 */
export function getUxPanels(levelId) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.get(`/levels/${levelId}/ux-panels`);
    });
}
/**
 * Get a specific UX panel by its ID.
 */
export function getUxPanelById(levelId, panelId) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.get(`/levels/${levelId}/ux-panels/${panelId}`);
    });
}
/**
 * Create a new UX panel for a level.
 */
export function createUxPanel(levelId, panelData) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.post(`/levels/${levelId}/ux-panels`, panelData);
    });
}
/**
 * Update an existing UX panel.
 */
export function updateUxPanel(levelId, panelId, panelData) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.patch(`/levels/${levelId}/ux-panels/${panelId}`, panelData);
    });
}
/**
 * Delete a UX panel.
 */
export function deleteUxPanel(levelId, panelId) {
    return __awaiter(this, void 0, void 0, function* () {
        yield client.delete(`/levels/${levelId}/ux-panels/${panelId}`);
    });
}
/**
 * Archive a UX panel.
 */
export function archiveUxPanel(levelId, panelId) {
    return __awaiter(this, void 0, void 0, function* () {
        yield client.patch(`/levels/${levelId}/ux-panels/${panelId}/archive`);
    });
}
/**
 * Restore a UX panel from archive.
 */
export function restoreUxPanel(levelId, panelId) {
    return __awaiter(this, void 0, void 0, function* () {
        yield client.patch(`/levels/${levelId}/ux-panels/${panelId}/restore`);
    });
}
/**
 * The archive: soft-deleted panels, restorable below the active list.
 * (Restore returns the panel unattached — deleting stripped its show_ux_panel
 * actions from every cell's outcomes; re-attach from the event editor.)
 */
export function getArchivedUxPanels(levelId) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.get(`/levels/${levelId}/ux-panels-archive`);
    });
}
